/**
 * Created by anatoly on 27.12.2024.
 */

const OrderHintView = function () {
    this.hintFinger = undefined;

    cleverapps.availableMove.on("hide", this.hide.bind(this));
    cleverapps.availableMove.on("order", this.show.bind(this));
};

OrderHintView.prototype.show = function (move) {
    this.hide();

    this.hintFinger = FingerView.hintTap(move.target, {
        delay: move.delay / 1000,
        repeatDelay: move.interval / 1000
    });
};

OrderHintView.prototype.hide = function () {
    FingerView.remove(this.hintFinger);
    this.hintFinger = undefined;
};
